<template>
  <div class="loader">
    <span class="spinner"></span>
    <span class="text">Loading...</span>
  </div>
</template>